import { render, staticRenderFns } from "./VNotification.vue?vue&type=template&id=10cfb344&scoped=true"
import script from "./VNotification.vue?vue&type=script&lang=js"
export * from "./VNotification.vue?vue&type=script&lang=js"
import style0 from "./VNotification.vue?vue&type=style&index=0&id=10cfb344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cfb344",
  null
  
)

export default component.exports